<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 20:20:24
 * @LastEditTime: 2019-09-04 10:42:36
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="container">
                <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
                        <el-form-item label="操作时间" style="text-align: center">
                        <el-col :span="11">
                            <el-date-picker type="date" placeholder="开始时间" v-model="form1.start_time"
                                            style="width: 100%;"></el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-date-picker type="date" placeholder="结束时间" v-model="form1.end_time"
                                            style="width: 100%;"></el-date-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="账号:">
                        <el-input v-model="form1.account" clearable  placeholder=""></el-input>
                    </el-form-item>
                  <el-form-item label="姓名:">
                        <el-input v-model="form1.allotment_name" clearable  placeholder=""></el-input>
                    </el-form-item>
                     <el-form-item label="操作内容:">
                        <el-input v-model="form1.content" clearable  placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSearch()">搜索</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                        ref="multipleTable"
                        :data="tableData1"
                        v-loading="loading"
                        border
                        stripe
                        style="width: 100%;margin: 20px">
                               <el-table-column
                            prop="created_at"
                            label="操作时间"
                            fixed>
                    </el-table-column>
                    <el-table-column
                            prop="account"
                            label="账号"
                            fixed>
                    </el-table-column>
                    <el-table-column
                            prop="allotment_name"
                            label="姓名"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="ip"
                            label="IP"
                            show-overflow-tooltip>
                    </el-table-column>
                   <el-table-column
                            prop="content"
                            label="操作内容"
                            show-overflow-tooltip>
                    </el-table-column>
                </el-table>
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="pageNo1"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="pageSize1"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize1">
                </el-pagination>
    </div>
</template>

<script>
    export default {
        name: "goods-onput",
        data() {
            return {
                loading:false,
                activeName: 'first',
                form1:{
                    product_sn:'',
                    product_name:'',
                    role:'',
                    isgift:'',
                    start_time:'',
                    end_time:""
                },
                form2:{
                    product_sn:'',
                    product_name:'',
                    role:'',
                    isgift:'',
                    custType:''
                },
                tableData1: [
           
                ],
                //分页
                pageNo1: 1,//页码
                pageSize1: 20,//每页现实的条数
                totalSize1: 0,//总条数
      
            }
        },
        methods: {
            onSearch(){ 
                var start='' ,end=''
                if(this.form1.start_time){
                start=this.moment(this.form1.start_time).format("YYYY-MM-DD")

                }   
                if(this.form1.end_time){
                  end =  this.moment(this.form1.end_time).format("YYYY-MM-DD")
                }
                this.$get('logistics','/logs',{
                     start_time:start,
                     end_time:end,
                     page:this.pageNo1,
                     per_page:this.pageSize1,
                     content:this.form1.content,
                     allotment_name:this.form1.allotment_name,
                    account:this.form1.account
                }).then(res=>{
                    this.totalSize1=res.meta.total
                    this.tableData1=res.data
                })
            },
            handleClick(tab) {
            },
            handleSizeChange1(val) {
                this.pageSize = val;
                this.pageNo = 1;
                this.onSearch();
            },
            handleCurrentChange1(val) {
                this.pageNo = val;

                this.onSearch();

            }
        },
        created() {
            this.onSearch()
        },
    }
</script>

<style lang="scss" scoped>
    .block{
        height: 100px;
        line-height: 24px;
        background-color: #eee;
        padding-left: 20px;
        margin-bottom: 20px;
    }

</style>